import { createLogic } from "redux-logic";
import { postPromoCode, removePromoCode } from "../../../data/api";
import { getCartId, setLocal } from "../../../data/localStorageHelpers";
import { setPageError } from "../../AppState/actions";
import { setCartData } from "../../Cart/actions";
import { IntegrationsActions, INTEGRATIONS_LOCAL_STORAGE_KEYS } from "../types";
var buyerFieldsPosted = createLogic({
    type: IntegrationsActions.INTEGRATIONS_EVENT_BUYER_FIELDS_POSTED,
    latest: true,
    process: function (_a, dispatch, done) {
        var _b, _c, _d, _e, _f;
        var getState = _a.getState, action = _a.action;
        var _g = getState(), integrations = _g.integrations, events = _g.events, cart = _g.cart;
        var config = integrations.integrations["REFERRAL_ROCK"].config;
        if (config) {
            var typedAction = action;
            var fieldToUse_1 = typedAction.payload.find(function (field) { return field.label.toUpperCase() === config.fieldLabel.toUpperCase(); });
            if (fieldToUse_1) {
                var referralRockCode_1 = fieldToUse_1.value;
                if (referralRockCode_1) {
                    var codes_1 = Object.keys(config.codes);
                    var matchedCode = codes_1.find(function (code) { return referralRockCode_1.toUpperCase().startsWith("".concat(code.toUpperCase())); });
                    if (matchedCode && ((_b = events.event) === null || _b === void 0 ? void 0 : _b.eventNumber)) {
                        var promoCode_1 = config.codes[matchedCode].promoCode;
                        var codeToRemove = (_c = cart.cart) === null || _c === void 0 ? void 0 : _c.promotions.find(function (promo) { return codes_1.find(function (code) { return promo.names.includes(config.codes[code].promoCode.toUpperCase()); }); });
                        if ((_d = cart.cart) === null || _d === void 0 ? void 0 : _d.promotions.some(function (promo) { return promo.names.includes(promoCode_1.toUpperCase()); })) {
                            //Already applied, so do nothing
                        }
                        else if (codeToRemove) {
                            removePromoCode(getCartId((_e = events.event) === null || _e === void 0 ? void 0 : _e.eventNumber), codeToRemove.id, events.event.eventNumber.toString()).then(function (_a) {
                                var data = _a.data;
                                dispatch(setCartData(data));
                            }).finally(function () {
                                setTimeout(function () {
                                    var _a, _b;
                                    if ((_a = events.event) === null || _a === void 0 ? void 0 : _a.eventNumber) {
                                        postPromoCode(getCartId((_b = events.event) === null || _b === void 0 ? void 0 : _b.eventNumber), promoCode_1, events.event.eventNumber.toString())
                                            .then(function (_a) {
                                            var data = _a.data;
                                            setLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE, referralRockCode_1);
                                            dispatch(setCartData(data));
                                        }).catch(function () {
                                            dispatch(setPageError({
                                                status: 500,
                                                error: "",
                                                message: "".concat(fieldToUse_1.label, " could not be applied. Please refresh and try again")
                                            }));
                                        }).finally(function () {
                                            done();
                                        });
                                    }
                                    else {
                                        done();
                                    }
                                }, 3000);
                            });
                        }
                        else {
                            setLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE, referralRockCode_1);
                            postPromoCode(getCartId((_f = events.event) === null || _f === void 0 ? void 0 : _f.eventNumber), promoCode_1, events.event.eventNumber.toString())
                                .then(function (_a) {
                                var data = _a.data;
                                dispatch(setCartData(data));
                            }).finally(function () {
                                done();
                            });
                        }
                    }
                    else {
                        done();
                    }
                }
                else {
                    done();
                }
            }
            else {
                done();
            }
        }
        else {
            done();
        }
    },
});
var exportable = [buyerFieldsPosted];
export default exportable;
